import { render, staticRenderFns } from "./AppChangelogDialog.vue?vue&type=template&id=60bd0af2&scoped=true"
import script from "./AppChangelogDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppChangelogDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppChangelogDialog.vue?vue&type=style&index=0&id=60bd0af2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bd0af2",
  null
  
)

export default component.exports